module.exports = __webpack_public_path__ + "static/media/game-result-zh-CN.fd2b51a0.png";